import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import { LocalizedText, NoContentPlaceholder, SpinningMask, Grid } from 'labguard-cdk'
import styles from './ChannelBlocks.scss'

export const tileHeight = 130
export const tileWidth = 280

const ChannelBlocks = ({ loading, channels = [], tile: Tile, height, scrollable }) => {
  const [ref, inView] = useInView()
  return (
    <SpinningMask loading={loading}>
      <div ref={ref}>
        <Grid
          scrollable={scrollable}
          className={classnames({ [styles.scrollable]: scrollable })}
          autoRows={`${tileHeight}px`}
          columns={`repeat(auto-fill, minmax(${tileWidth}px, 1fr))`}
          gap="1rem"
          minHeight={height}
        >
          {!channels.length && (
            <NoContentPlaceholder className={styles.empty}>
              <LocalizedText id="WEB_NO_CHANNEL" />
            </NoContentPlaceholder>
          )}
          {inView && !!channels.length && channels.map(channel => <Tile key={channel.id} channel={channel} />)}
        </Grid>
      </div>
    </SpinningMask>
  )
}

ChannelBlocks.propTypes = {
  loading: PropTypes.bool,
  scrollable: PropTypes.bool,
  channels: PropTypes.array,
  tile: PropTypes.any.isRequired,
  height: PropTypes.string,
}

export default ChannelBlocks
